module.exports = __webpack_public_path__ + "img/居家-上課證明-A4.e3897593.jpg";